import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
  }, []);

  const cards = [
    { label: "Interviews", key: "interviews", to: "/admin/interviews" },
    { label: "Operators", key: "operators", to: "/admin/operators" },
    { label: "Topics", key: "topics", to: "/admin/topics" },
    { label: "Industries", key: "industries", to: "/admin/industries" },
    { label: "Collections", key: "collections", to: "/admin/collections" },
    { label: "Applications", key: "applications", to: "/admin/submissions" },
    { label: "Nominations", key: "nominations", to: "/admin/submissions" },
    { label: "Subscribers", key: "subscribers", to: "/admin/submissions" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="eyebrow text-oc-coral mb-3">Console</div>
      <h1 className="font-editorial text-4xl md:text-5xl text-oc-ink">Editorial dashboard</h1>
      <p className="mt-3 font-editorial text-lg text-oc-ink-soft">A quick pulse of the publication.</p>

      <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3">
        {cards.map((c) => (
          <Link
            key={c.label}
            to={c.to}
            data-testid={`stat-${c.key}`}
            className="p-6 border border-oc-hairline hover:border-oc-ink transition-colors bg-white"
          >
            <div className="eyebrow text-oc-ink-muted mb-2">{c.label}</div>
            <div className="font-editorial text-4xl text-oc-ink">
              {stats ? stats[c.key] : ", "}
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-12 flex flex-wrap gap-3">
        <Link to="/admin/interviews/new" className="h-12 px-5 bg-oc-blue text-white font-ui text-xs font-bold uppercase tracking-widest flex items-center hover:bg-oc-blue-hover">
          New Interview
        </Link>
        <Link to="/admin/operators" className="h-12 px-5 border border-oc-ink font-ui text-xs font-bold uppercase tracking-widest flex items-center hover:bg-oc-ink hover:text-white">
          Manage Operators
        </Link>
        <Link to="/admin/submissions" className="h-12 px-5 border border-oc-ink font-ui text-xs font-bold uppercase tracking-widest flex items-center hover:bg-oc-ink hover:text-white">
          Review Submissions
        </Link>
      </div>
    </div>
  );
}
